import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
  getSystemSettings,
  changeNumberFormat,
} from "../../../../functions/Functions";
import { useCustomHooks } from "../../../../functions/Hooks";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from 'moment';
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//pages & includes
import ReportSidebar from "./ReportSidebar";
import PosSessionActivityReport from "./PosSessionActivityReport";
import BranchExpenseReport from "./BranchExpenseReport";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import { useGeneralHooks } from "../../../../hooks/generalHooks";

const WorkPeriodReport = () => {
  const { t } = useTranslation();
  const { roundOffPrice } = useCustomHooks();
  const { dayEndCash } = useGeneralHooks();
  //getting context values here
  let { loading, setLoading, dataPaginating, generalSettings } = useContext(SettingsContext);
  let { branchForSearch } = useContext(RestaurantContext);

  let [newWorkPeriodReport, setNewWorkPeriodReport] = useState(null);

  //all data
  const [reportData, setReportData] = useState(null);
  const [stockData, setStockData] = useState(null);
  

  const componentRef = useRef();
  const componentRef1 = useRef();
  //settle order
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [generatedReport, setGeneratedReport] = useState(false);
  const [stockReport, setStockReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  const componentRefThermal = useRef();
  const componentRefStockThermal = useRef();
  //useEffect == componentDidMount()
  const { authUserInfo } = useContext(UserContext);
  const [option,setOption] = useState("excel");
  const [reportOption, setReportOption] = useState("finish_good");
  const [selectedReportType, setSelectedReportType] = useState({
    label: _t(t("Work Period Report")),
    value: "work_period",
  });
  const [posSessionData, setPosSessionData] = useState(null);
  const componentRefPosSession = useRef();

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
  
  }, [generalSettings]);

  const handleBranch = (branch) => {
    setNewWorkPeriodReport({
      ...newWorkPeriodReport,
      branch,
    });
    // setBranch(branch);
  };
  // excel or print option
  const handleOption  = (e) =>{
    setOption(e.target.value)
  }

  //set report option
  const handleReportOption  = (e) =>{
    setReportOption(e.target.value)
  }

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: "@page { margin: 20px }"
  });

  const thermalPrintStock = useReactToPrint({
    content: () => componentRefStockThermal.current,
    pageStyle: "@page { margin: 20px }"
  });

  const thermalPrintPosSession = useReactToPrint({
    content: () => componentRefPosSession.current,
    pageStyle: "@page { margin: 15px }"
  });

  const [expenseData, setExpenseData] = useState(null);
  const componentRefExpense = useRef();
  const thermalPrintExpense = useReactToPrint({
    content: () => componentRefExpense.current,
    pageStyle: "@page { margin: 15px }"
  });
  
  // get branch wise stock
  const getBranchWiseStock = () => {
    setStockData(null);
    let $branch_id = "";
    if (
      authUserInfo.details !== null &&
      (authUserInfo.details.user_type !== "staff"
      && authUserInfo.details.user_type !== "manager")
    ) {
      $branch_id = newWorkPeriodReport?.branch?.id;
    } else {
      $branch_id = authUserInfo?.details?.branch_id;
    }

    if ($branch_id !== undefined && startDate !== null) {
      setLoading(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");

      const url = BASE_URL + "/settings/day-end-physical-stock-report";

      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("branch_id", $branch_id);
      formData.append("type", reportOption)

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setStockData(res.data.data);

          setLoading(false);
          setStockReport(true);
          if(option==="excel"){
            componentRef1.current.handleDownload();
          }else{
            thermalPrintStock();
          }
          setNewWorkPeriodReport(null);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      toast.error(
        `${_t(t("Please select date and branch to generate report"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };
  
  //get BranchWise reports filter
  const getBranchWiseSelected = () => {
    setReportData(null);
    let $branch_id = "";
    if (
      authUserInfo.details !== null &&
      (authUserInfo.details.user_type !== "staff"
      && authUserInfo.details.user_type !== "manager")
    ) {
      $branch_id = newWorkPeriodReport?.branch?.id;
    } else {
      $branch_id = authUserInfo?.details?.branch_id;
    }
    
    let isValid = false;
    if ($branch_id !== undefined) {
      if (selectedReportType?.value === "pos_session") {
        isValid = endDate !== null;
      } else {
        isValid = startDate !== null && endDate !== null;
      }
    }

    if (isValid) {
      setLoading(true);
      let fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
      let toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

      let url;
      let formData = {};
      if (selectedReportType?.value === "pos_session") {
        url = BASE_URL + "/settings/unified-pos-report";
        formData.work_period_id = "";
        formData.date = toDate;
        formData.branch_id = $branch_id;
      } else if (selectedReportType?.value === "expense_report") {
        url = BASE_URL + "/settings/shift-branch-expense-report";
        formData.work_period_id = "";
        formData.date = toDate;
        formData.branch_id = $branch_id;
      } else {
        url = BASE_URL + "/settings/get-work-period-report";
        formData.fromDate = fromDate;
        formData.toDate = toDate;
        formData.branch_id = $branch_id;
      }
      
      console.log("formData ", formData);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("WorkPeriodReportResult/PosSessionResult", res);
          
          if (selectedReportType?.value === "pos_session") {
            console.log("PosSessionResult", res.data);
            setGeneratedReport(true);
            setPosSessionData(res.data.data);
            setTimeout(() => {
              thermalPrintPosSession();
            }, 100);
            setLoading(false);
          } else if (selectedReportType?.value === "expense_report") {
            console.log("ExpenseReportResult", res.data);
            setGeneratedReport(true);
            if (res.data.status === "success") {
              setExpenseData(res.data.data);
              setTimeout(() => {
                thermalPrintExpense();
              }, 100);
            } else {
              toast.error(res.data.message || "Failed to fetch report", {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              });
            }
            setLoading(false);
          } else {
            setReportData(res.data[0]);
            setGeneratedReport(true);
            setLoading(false);
            if(option==="excel"){
              componentRef.current.handleDownload();
            }else{
              thermalPrint();
            }
          }
          
          setNewWorkPeriodReport(null);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      toast.error(
        `${_t(t("Please select date and branch to generate report"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  let total_qty = 0;
  let total_amount = 0;
  let totalExpAmount = 0; 
  let totalExp = 0;
  let totalPurchaseAmount = 0;
  let totalPurchase = 0;

  let total_qty_print = 0;
  let total_amount_print = 0;

  let departPaymentSales = [];
  for (const keys in reportData?.data?.payment_sales) {
    departPaymentSales.push(
      <tr>
        <th className="w-50 table-text text-capitalize align-middle text-left border-0 p-1">
          {keys}
        </th>

        <td className="w-25 table-text text-capitalize align-middle text-left border-0 p-1">{reportData?.data?.payment_sales[keys]?.payment_count && Math.round(reportData?.data?.payment_sales[keys]?.payment_count, 2)}</td>
         
        <td className="w-25 table-text text-capitalize align-middle text-right border-0 p-1">
          {Math.round(reportData?.data?.payment_sales[keys]?.amount ?? reportData?.data?.payment_sales[keys], 2)}
        </td>
      </tr>
    );
  }

  // Order types
  let orderTypesSales = [];
  for (const keys in reportData?.data?.order_type_sales) {
    orderTypesSales.push(
      <tr>
        <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
          {keys}
        </th>
        <td className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
          {reportData?.data && reportData.data?.order_type_sales_num[keys]}
        </td>
        <td className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
          {reportData?.data && reportData.data?.order_type_sales[keys]}
        </td>
      </tr>
    );
  }

  // Party Wise
  let partyWiseSales = [];
  for (const keys in reportData?.data?.party_wise_sales) {
    partyWiseSales.push(
      <tr>
        <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
          {keys}
        </th>
        <td className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
          {reportData?.data.party_wise_sales_no[keys]}
        </td>
        <td className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
          {reportData?.data.party_wise_sales[keys]}
        </td>
      </tr>
    );
  }

  return (
    <>
      <Helmet>
        <title>{_t(t("Work Period Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Work Period Report"
        sheet="sheet 1"
        buttonText="Sales Detail"
        ref={componentRef}
      />

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="stock-to-xls"
        filename="Day End Stock Report"
        sheet="sheet 1"
        buttonText="Sales Detail"
        ref={componentRef1}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="5" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Work Period Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          To&nbsp;
                                          <Moment format="LL">
                                            {endDate}
                                          </Moment>
                                        </p>
                                        <p className="text-center">
                                          {reportData.data.day_status}
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                <tr>
                                  <th>
                                    Report Date
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.report_date}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Terminal
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.branch_name}
                                  </td>
                                </tr>
                                {/* <tr>
                                  <th className="sm-text text-capitalize align-middle text-center border-1 border">
                                    Open Date
                                  </th>
                                  <td></td>
                                  <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                    {reportData.data.workperiod_status.start}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="sm-text text-capitalize align-middle text-center border-1 border">
                                    Close Date
                                  </th>
                                  <td></td>
                                  <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                    {reportData.data.workperiod_status.end}
                                  </td>
                                </tr> */}
                                <tr>
                                  <th>
                                    User Name
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.user.name}
                                  </td>
                                </tr>
                                <tr></tr>
                                <tr>
                                  <th
                                    colspan="3"
                                  >
                                    SALES DETAILS
                                  </th>
                                </tr>
                                <tr>
                                  <th>
                                    Sales Variance
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.sales_details?.sale_variance}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Gross Sales
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.sales_details.gross_total}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Discount
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.sales_details?.discount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Cancelled
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.sales_details?.cancelled}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Refund
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.sales_details?.total_refund}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Free of Cost
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.sales_details?.total_foc}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Net Sales
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.sales_details?.net_sales}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Tax Amount
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.sales_details?.tax_amount}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Net Sales Including Tax
                                  </th>
                                  <td></td>
                                  <td>
                                    {
                                      reportData.data.sales_details
                                        ?.taxable_total
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Delivery Charges
                                  </th>
                                  <td></td>
                                  <td>
                                    {
                                      reportData.data.sales_details
                                        ?.service_charge
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Service Charges
                                  </th>
                                  <td></td>
                                  <td>
                                    {
                                      reportData.data.sales_details
                                        ?.service_amount
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Department Commission
                                  </th>
                                  <td></td>
                                  <td>
                                    {
                                      reportData.data.sales_details
                                        ?.dept_commission
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Pos Service Fee
                                  </th>
                                  <td></td>
                                  <td>
                                    {
                                      reportData.data.sales_details
                                        ?.pos_fee
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Total Collected
                                  </th>
                                  <td></td>
                                  <td>
                                    {
                                      reportData.data.sales_details
                                        ?.total_collected
                                    }
                                  </td>
                                </tr>
                                <tr></tr>
                                <tr>
                                  <th
                                    colspan="3"
                                  >
                                    INSIGHT
                                  </th>
                                </tr>
                                <tr>
                                  <th>
                                    Number Of Orders
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.insights?.number_of_orders}
                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    Number Of Customers
                                  </th>
                                  <td></td>
                                  <td>
                                    {reportData.data.insights?.number_of_customers}
                                  </td>
                                </tr>
                                <tr></tr>
                                <tr>
                                  <th
                                    colspan="3"
                                  >
                                    PAYMENT WISE SALES
                                  </th>
                                </tr>
                                {departPaymentSales}
                                <tr>
                                  <th>
                                    Total
                                  </th>
                                  <th></th>
                                  <th>
                                    {reportData.data.sales_details?.payment_type_total}
                                  </th>
                                </tr>
                                <tr></tr>
                                <tr>
                                  <th
                                    colspan="3"
                                  >
                                    ORDER TYPE SALES
                                  </th>
                                </tr>
                                {orderTypesSales}
                                <tr>
                                  <th>
                                    Total
                                  </th>
                                  <th></th>
                                  <th>
                                    {reportData.data.sales_details?.order_type_total}
                                  </th>
                                </tr>
                                <tr></tr>
                                <tr>
                                  <th
                                    colspan="3"
                                  >
                                    PARTY WISE SALES
                                  </th>
                                </tr>
                                {partyWiseSales}
                                <tr>
                                  <th>
                                    Total
                                  </th>
                                  <th></th>
                                  <th>
                                    {reportData.data.sales_details?.party_total}
                                  </th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                                <tr>
                                  <th
                                    colspan="5"
                                  >
                                    Item Details
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Food Group"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Food Item"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Variation"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Qty"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                </tr>
                                {reportData.data.order_details.map(
                                  (item, i) => {
                                    total_qty += parseFloat(item.quantity);
                                    total_amount += parseFloat(item.price);
                                    return (
                                      <tr>
                                        <td>
                                          {item.food_group}
                                        </td>
                                        <td>
                                          {item.food_item}
                                        </td>
                                        <td>
                                          {item.variation}
                                        </td>
                                        <td>
                                          {item.quantity}
                                        </td>
                                        <td>
                                          {item.price}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                                <tr>
                                  <th
                                    colspan="3"
                                  >
                                    Total
                                  </th>
                                  <th>{total_qty}</th>
                                  <th>{roundOffPrice(total_amount)}</th>
                                </tr>
                                {reportData.data?.variation_by_group && Object.keys(reportData.data.variation_by_group).length > 0 && (
                                  <>
                                    <tr></tr>
                                    <tr>
                                      <th colspan="5">
                                        Variation By Group
                                      </th>
                                    </tr>
                                    <tr>
                                      <th colspan="2">{_t(t("Item"))}</th>
                                      <th colspan="2">{_t(t("Variation"))}</th>
                                      <th>{_t(t("Qty"))}</th>
                                    </tr>
                                    {Object.keys(reportData.data.variation_by_group).map(foodItem => (
                                      Object.keys(reportData.data.variation_by_group[foodItem]).map((variationName, vIndex) => (
                                        <tr key={`${foodItem}-${variationName}`}>
                                          <td colspan="2">{foodItem}</td>
                                          <td colspan="2">{variationName}</td>
                                          <td>{reportData.data.variation_by_group[foodItem][variationName]}</td>
                                        </tr>
                                      ))
                                    ))}
                                  </>
                                )}
                                <tr></tr>
                                {/* <tr>
                                  <th
                                    colspan="2"
                                  >
                                    Menu Mix Items
                                  </th>
                                </tr> */}
                                {/* <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Item"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Qty"))}
                                  </th>
                                </tr> */}
                                {/* {reportData.data?.item_menu_mix_details && Object.keys(reportData.data.item_menu_mix_details).map(
                                  (group, i) => {
                                    return (
                                      <>
                                        <tr key={i}>
                                          <td
                                            scope="row"
                                            colSpan={2}
                                          >
                                            {group}
                                          </td>
                                        </tr>
                                        {reportData.data.item_menu_mix_details && reportData.data.item_menu_mix_details[group].map(
                                          (item) => {
                                            return (
                                              <tr>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.item_name}
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.qty}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                      </>
                                    );
                                  }
                                )} */}
                                <tr></tr>
                                <tr>
                                  <th>
                                    Total Collected
                                  </th>
                                  <td></td>
                                  <th>
                                    {reportData.data.sales_details?.total_collected}
                                  </th>
                                </tr>
                                <tr>
                                  <th>
                                    Day End Cash
                                  </th>
                                  <th></th>
                                  <th>
                                    {reportData.data.sales_details?.day_end_cash}
                                  </th>
                                </tr>
                                <tr>
                                  <th>
                                    Variance
                                  </th>
                                  <th></th>
                                  <th>
                                    {(() => {
                                      const diff = Number(changeNumberFormat(reportData.data.sales_details?.total_collected)) -
                                      Number(changeNumberFormat(reportData.data.sales_details?.day_end_cash));

                                      return `${diff} ${diff > 0 ? "(excess)" : (diff < 0 ? "(short)" : "")}`;
                                    })()}
                                  </th>
                                </tr>

                                <>
                                  {reportData?.data && reportData.data?.expenses && 
                                    parseInt(getSystemSettings(generalSettings, "view_expense")) === 1 && (
                                      <>
                                      <tr></tr>
                                      <tr><th colspan="2">Expense Details</th></tr>
                                      <tr>
                                        <th>
                                          Type
                                        </th>

                                        <th>
                                          Amount
                                        </th>
                                      </tr>
                                  
                                      {reportData &&
                                        reportData.data?.expenses !== null && (
                                        reportData.data.expenses && Object.entries(reportData.data.expenses)?.map((food)=>{
                                          totalExpAmount += parseFloat(food[1]);                    
                                          return(
                                            <tr>
                                              <td>{food[0]}</td>                          
                                              <td>{roundOffPrice(food[1])}</td>
                                            </tr>
                                          )
                                        })
                                        )
                                      }
                                      <tr>
                                        <th>Total</th>                       
                                        <th>{roundOffPrice(totalExpAmount)}</th>
                                      </tr>                       
                                      </>
                                    )
                                  }

                                  {reportData?.data && reportData.data?.cash_purchase_invoices && Object.keys(reportData.data.cash_purchase_invoices).length > 0 && 
                                    parseInt(getSystemSettings(generalSettings, "enable_pi_zreport")) === 1 && (
                                      <>
                                      <tr></tr>
                                      <tr><th colSpan="2">Purchase Details</th></tr>
                                      <tr>
                                        <th>
                                          Supplier
                                        </th>

                                        <th>
                                          Amount
                                        </th>
                                      </tr>
                                  
                                      {reportData &&
                                        reportData.data?.cash_purchase_invoices !== null && (
                                        reportData.data.cash_purchase_invoices && Object.entries(reportData.data.cash_purchase_invoices)?.map((pi)=>{
                                          totalPurchaseAmount += parseFloat(pi[1]);                    
                                          return(
                                            <tr>
                                              <td>{pi[0]}</td>                          
                                              <td>{roundOffPrice(pi[1])}</td>
                                            </tr>
                                          )
                                        })
                                        )
                                      }
                                      <tr>
                                        <th>Total</th>                       
                                        <th>{roundOffPrice(totalPurchaseAmount)}</th>
                                      </tr>
                                      {reportData.data?.sales_details?.total_cash !== undefined && reportData.data?.sales_details?.total_cash !== null && (
                                        <tr>
                                          <th>Net Cash After Purchase</th>
                                          <th>{roundOffPrice(Number(reportData.data.sales_details.total_cash) - totalExpAmount - totalPurchaseAmount)}</th>
                                        </tr>
                                      )}
                                      </>
                                    )
                                  }
                                </>
                                {
                                  dayEndCash && reportData.data?.denominator ? (
                                    <>
                                      <tr></tr>
                                      <tr>
                                        <th scope="col">Type</th>
                                        <th scope="col">Total Collected</th>
                                        <th scope="col">Total Payable</th>
                                        <th scope="col">Variance</th>
                                      </tr>                                                      
                                      <tr>
                                        <td>Cash</td>
                                        <td>{reportData.data.denominator?.collected_amount ?? 0}</td>
                                        <td>{reportData.data.denominator?.total_payable_amount ?? 0}</td>
                                        <td>{roundOffPrice(reportData.data.denominator?.variance)}</td>
                                      </tr>
                                      {(reportData.data.denominator?.card_collected_amount !== undefined || reportData.data.denominator?.card_variance !== undefined) && (
                                        <tr>
                                          <td>Card</td>
                                          <td>{reportData.data.denominator?.card_collected_amount ?? 0}</td>
                                          <td>{reportData.data.denominator?.card_total_payable_amount ?? 0}</td>
                                          <td>{roundOffPrice(reportData.data.denominator?.card_variance)}</td>
                                        </tr>
                                      )}
                                    </>
                                  ) : ""
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* excel Button stock */}
      <div className="d-none">
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {stockData !== null &&
                  stockData !== undefined &&
                  stockReport === true && (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="stock-to-xls"
                          >
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="17" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Day End Stock Report
                                      </h3>
                                      <p className="mt-0 text-center lg-text">
                                        {newWorkPeriodReport?.branch?.name}
                                      </p>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">
                                          {startDate}
                                        </Moment>
                                        To&nbsp;
                                        <Moment format="LL">
                                          {endDate}
                                        </Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr className="align-middle sm-text">
                                <th>
                                  Group
                                </th>
                                <th>
                                  Item
                                </th>
                                <th>
                                  Unit
                                </th>
                                <th>
                                  Opening
                                </th>

                                <th>
                                  Purchase
                                </th>

                                <th>
                                  Trans In
                                </th>

                                <th>
                                  Prod In
                                </th>

                                <th>
                                  Total
                                </th>

                                <th>
                                  Trans Out
                                </th>

                                <th>
                                  Sale
                                </th>

                                <th>
                                  Made Void
                                </th>

                                <th>
                                  Discard
                                </th>

                                <th>
                                  Production
                                </th>

                                <th>
                                  Total
                                </th>

                                <th>
                                  Sys End Count
                                </th>

                                <th>
                                  Phy End Count
                                </th>

                                <th>
                                  Diff
                                </th>

                                {/* <th scope="col">
                                  Amt
                                </th> */}
                              </tr>                                                           
                            </thead>
                            <tbody className="align-middle">
                              {
                                stockData && stockData?.map((value)=>{  
                                const totalIn = parseFloat(value?.Opening) + parseFloat(value?.Purchase) + parseFloat(value?.TrasferInn) + parseFloat(value?.ProductionInn); 
                                const totalOut =  parseFloat(value?.TrasferOut) + parseFloat(value?.Sales) + parseFloat(value?.MadeVoid) + parseFloat(value?.Discard) + parseFloat(value.Production);
                                const sysEndCount = totalIn - totalOut;
                                const diff = parseFloat(value?.PhysicalEndCount) - sysEndCount;
                                return (
                                  <tr className="align-middle sm-text">
                                    <td>{value?.group_name}</td>
                                    <td>{value?.name}</td>
                                    <td>{value?.unit || "PCS"}</td>
                                    <td>{value?.Opening}</td>
                                    <td>{roundOffPrice(value?.Purchase)}</td>
                                    <td>{roundOffPrice(value?.TrasferInn)}</td>
                                    <td>{roundOffPrice(value?.ProductionInn)}</td>
                                    <td>{roundOffPrice(totalIn)}</td>
                                    <td>{roundOffPrice(value?.TrasferOut)}</td> 
                                    <td>{roundOffPrice(value?.Sales)}</td>
                                    <td>{roundOffPrice(value?.MadeVoid)}</td>
                                    <td>{roundOffPrice(value?.Discard)}</td>
                                    <td>{roundOffPrice(value?.Production)}</td>
                                    <td>{roundOffPrice(totalOut)}</td>
                                    <td>{roundOffPrice(sysEndCount)}</td>
                                    <td>{value?.PhysicalEndCount}</td>
                                    <td>{roundOffPrice(diff)}</td>
                                    {/* <td>0</td> */}
                                  </tr>
                                )
                                })
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* stock print */}
      <div className="d-none">
        <div ref={componentRefStockThermal}>
          <div className="fk-print">
            {
              stockData &&
              stockData !== null && stockReport && (
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-12">
                        <div className="xslg-text text-center mb-0">
                          {siteName}
                        </div>
                        <div className="mt-2 xslg-text text-center">
                          Day End Stock Report
                        </div>
                        <p className="mt-2 xslg-text text-center">
                          FROM&nbsp;
                          <Moment format="LL">
                            {startDate}
                          </Moment>
                          To&nbsp;
                          <Moment format="LL">
                            {endDate}
                          </Moment>
                        </p>
                        <p className="mt-0 mb-2 text-center lg-text">
                          {newWorkPeriodReport?.branch?.name}
                        </p>
                        <p className="mt-0 mb-1 text-center lg-text">
                          Print Time:{" "} 
                          <Moment format="LLL">
                            {new Date()}
                          </Moment>
                        </p>
                      </div>
                    </div>
                    {/*stock wise report */}
                    <div className="col-12 mt-2">
                      <table className="table table-bordered-sm table-hover">
                        <thead className="align-middle sm-text">
                          <tr className="align-middle">
                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Group
                            </th>
                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Item
                            </th>
                            <th>
                              Unit
                            </th>
                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Opening
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Purchase
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Trans In
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Prod In
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Total
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Trans Out
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Sale
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Made Void
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Discard
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Production
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Total
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Sys End Count
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Phy End Count
                            </th>

                            <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Diff
                            </th>

                            {/* <th scope="col"
                              className="text-capitalize align-middle text-center border-1 border" style={{ minWidth: "40px", padding:"3px" }}>
                              Amt
                            </th> */}
                          </tr> 
                        </thead>
                        <tbody className="align-middle sm-text">
                          {
                            stockData && stockData?.map((value)=>{  
                            const totalIn = parseFloat(value?.Opening) + parseFloat(value?.Purchase) + parseFloat(value?.TrasferInn) + parseFloat(value?.ProductionInn); 
                            const totalOut =  parseFloat(value?.TrasferOut) + parseFloat(value?.Sales) + parseFloat(value?.MadeVoid) + parseFloat(value?.Discard) + parseFloat(value.Production);
                            const sysEndCount = totalIn - totalOut;
                            const diff = parseFloat(value?.PhysicalEndCount) - sysEndCount;
                            return(
                              <tr className="align-middle">
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.group_name}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.name}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.unit || "PCS"}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.Opening}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.Purchase)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.TrasferInn)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.ProductionInn)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(totalIn)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.TrasferOut)}</td> 
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.Sales)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.MadeVoid)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.Discard)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(value?.Production)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(totalOut)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(sysEndCount)}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{value?.PhysicalEndCount}</td>
                                <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>{roundOffPrice(diff)}</td>
                                {/* <td className="text-capitalize align-middle text-center border" style={{ minWidth: "40px", padding:"3px" }}>0</td> */}
                              </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                      
                    </div>
                  </div> 
                </div> 
              )
            }
          </div> 
        </div> 
      </div>
      
      <PosSessionActivityReport
        componentRefPosSession={componentRefPosSession}
        reportData={posSessionData}
      />
      <BranchExpenseReport
        componentRefExpense={componentRefExpense}
        reportData={expenseData}
      />

      {/* print */}
      <div className="d-none">
        <div ref={componentRefThermal}>
          <div className="fk-print">
            {
              reportData &&
              reportData !== null && (
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-12">
                        <div className="xslg-text text-center mb-0">
                          {siteName}
                        </div>
                        <div className="mt-2 xslg-text text-center">
                          Work Period Report
                        </div>
                        <p className="mt-2 xslg-text text-center">
                          FROM&nbsp;
                          <Moment format="LL">
                            {startDate}
                          </Moment>
                          To&nbsp;
                          <Moment format="LL">
                            {endDate}
                          </Moment>
                        </p>
                        <p className="mt-0 text-center lg-text">
                          Print Time:{" "} 
                          <Moment format="LLL">
                            {new Date()}
                          </Moment>
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="mt-0 lg-text text-center">
                        {reportData.data.day_status}
                      </p>
                    </div>
                    {/*production wise report */}
                    <div className="col-12 mt-2">
                      <table className="table">
                        <tbody className="align-middle">
                          <tr className="align-middle">
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Report Date
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.report_date}
                            </td>
                          </tr>
                          <tr className="align-middle">
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Terminal
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.branch_name}
                            </td>
                          </tr>
                          <tr className="align-middle">
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              User Name
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.user.name}
                            </td>
                          </tr>

                        </tbody> 
                      </table>   
                      <div className="myBorder my-2"></div>
                        <div
                          className="mt-2 mb-1 font-weight-md xslg-text text-center"
                        >
                          SALES DETAILS
                        </div>
                      
                      <table className="table">  
                        <tbody>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Sales Variance
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details?.sale_variance}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Gross Sales
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details.gross_total}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Discount
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details?.discount}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Cancelled
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details.cancelled}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Refund
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details.total_refund}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Free of Cost
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details?.total_foc}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Net Sales
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details?.net_sales}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Tax Amount
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details?.tax_amount}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Net Sales Including Tax
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {
                                reportData.data.sales_details
                                  ?.taxable_total
                              }
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Delivery Charges
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {
                                reportData.data.sales_details
                                  ?.service_charge
                              }
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Service Charges
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {
                                reportData.data.sales_details
                                  ?.service_amount
                              }
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Department Commission
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {
                                reportData.data.sales_details
                                  ?.dept_commission
                              }
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Total Collected
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {
                                reportData.data.sales_details
                                  ?.total_collected
                              }
                            </td>
                          </tr>
                        </tbody>
                      </table> 
                      <div className="myBorder my-2"></div>
                        <div
                          className="mt-2 mb-1 font-weight-md xslg-text text-center"
                        >
                          INSIGHT
                        </div>
                        <table className="table">
                        <tbody>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Number Of Orders
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.insights?.number_of_orders}
                            </td>
                          </tr>
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Number Of Customers
                            </th>
                            <td className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.insights?.number_of_customers}
                            </td>
                          </tr>
                        </tbody> 
                        </table>
                        <div className="myBorder my-2"></div>
                        <div
                          className="mt-2 mb-1 font-weight-md xslg-text text-center"
                        >
                          PAYMENT WISE SALES
                        </div>
                      
                        <table className="table">
                        <tbody>
                        {departPaymentSales}
                          <tr>
                            <th className="table-text text-capitalize align-middle text-left border-0 p-1">
                              Total
                            </th>
                            <th className="border-0 p-1"></th>
                            <th className="table-text text-capitalize align-middle text-right border-0 p-1">
                              {reportData.data.sales_details?.payment_type_total}
                            </th>
                          </tr>
                        </tbody> 
                        </table>  
                        <div className="myBorder my-2"></div>

                        <div
                          className="mt-2 mb-1 font-weight-md xslg-text text-center"
                        >
                          ORDER TYPE SALES
                        </div>
                      
                        <table className="table">
                        <tbody>
                          {orderTypesSales}
                          <tr>
                            <th colspan="2" className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              Total
                            </th>
                            <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              {reportData.data.sales_details?.order_type_total}
                            </th>
                          </tr>
                        </tbody> 
                        </table>  
                        <div className="myBorder my-2"></div>

                        <div
                          className="mt-2 mb-1 font-weight-md xslg-text text-center"
                        >
                          PARTY WISE SALES
                        </div>
                      
                        <table className="table">
                        <tbody>
                          {partyWiseSales}
                          <tr>
                            <th colspan="2" className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              Total
                            </th>
                            <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              {reportData.data.sales_details?.party_total}
                            </th>
                          </tr>
                          </tbody>
                        </table>  
                      <div className="myBorder my-2"></div>

                      <div
                        className="mt-2 mb-1 font-weight-md xslg-text text-center"
                      >
                        ITEM DETAILS
                      </div>
    
                      <table className="table">
                        <thead>
                          <tr>
                          <th
                            scope="col"
                            className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                          >
                            {_t(t("Food Group"))}
                          </th>
                          <th
                            scope="col"
                            className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                          >
                            {_t(t("Food Item"))}
                          </th>
                          <th
                            scope="col"
                            className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                          >
                            {_t(t("Variation"))}
                          </th>
                          <th
                            scope="col"
                            className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                          >
                            {_t(t("Qty"))}
                          </th>
                          <th
                            scope="col"
                            className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                          >
                            {_t(t("Amount"))}
                          </th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportData.data.order_details.map(
                            (item, i) => {
                              total_qty_print += parseFloat(item.quantity);
                              total_amount_print += parseFloat(item.price);
                              return (
                                <tr>
                                  <td
                                    className="table-text text-capitalize align-middle text-center border-1 border-dark p-1"
                                  >
                                    {item.food_group}
                                  </td>
                                  <td
                                    className="table-text text-capitalize align-middle text-center border-1 border-dark p-1"
                                  >
                                    {item.food_item}
                                  </td>
                                  <td
                                    className="table-text text-capitalize align-middle text-center border-1 border-dark p-1"
                                  >
                                    {item.variation}
                                  </td>
                                  <td
                                    className="table-text text-capitalize align-middle text-center border-1 border-dark p-1"
                                  >
                                    {item.quantity}
                                  </td>
                                  <td
                                    className="table-text text-capitalize align-middle text-center border-1 border-dark p-1"
                                  >
                                    {item.price}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                          <tr>
                            <th
                              colspan="3"
                              className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                            >
                              Total
                            </th>
                            <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">{total_qty_print}</th>
                            <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">{roundOffPrice(total_amount_print)}</th>
                          </tr>
                        </tbody>
                      </table>

                      {reportData.data?.variation_by_group && Object.keys(reportData.data.variation_by_group).length > 0 && (
                        <>
                          <div className="mt-2 mb-1 font-weight-md xslg-text text-center">
                            Variation By Group
                          </div>
                          <table className="table">
                            <thead>
                              <tr>
                                <th
                                  scope="col"
                                  className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                                >
                                  {_t(t("Item"))}
                                </th>
                                <th
                                  scope="col"
                                  className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                                >
                                  {_t(t("Variation"))}
                                </th>
                                <th
                                  scope="col"
                                  className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                                >
                                  {_t(t("Qty"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(reportData.data.variation_by_group).map(foodItem => (
                                Object.keys(reportData.data.variation_by_group[foodItem]).map((variationName, vIndex) => (
                                  <tr key={`${foodItem}-${variationName}`}>
                                    <td className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                                      {foodItem}
                                    </td>
                                    <td className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                                      {variationName}
                                    </td>
                                    <td className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                                      {reportData.data.variation_by_group[foodItem][variationName]}
                                    </td>
                                  </tr>
                                ))
                              ))}
                            </tbody>
                          </table>
                        </>
                      )}

                      {/* <div
                        className="mt-2 mb-1 font-weight-md xslg-text text-center"
                      >
                        Menu Mix Item
                      </div> */}

                      <table className="table">
                        {/* <thead>
                          <tr>
                            <th
                              scope="col"
                              className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                            >
                              {_t(t("Item"))}
                            </th>
                            <th
                              scope="col"
                              className="lg-text font-weight-md text-capitalize align-middle text-center border-1 border-dark p-1"
                            >
                              {_t(t("Qty"))}
                            </th>
                          </tr>
                        </thead> */}
                        <tbody>
                          {/* {reportData.data?.item_menu_mix_details && Object.keys(reportData.data.item_menu_mix_details).map(
                            (group, i) => {
                              return (
                                <>
                                  <tr key={i}>
                                    <td
                                      colSpan={2}
                                      className="table-text text-capitalize align-middle text-center border-1 border-dark p-1"
                                    >
                                      {group}
                                    </td>
                                  </tr>
                                  {reportData.data.item_menu_mix_details && reportData.data.item_menu_mix_details[group].map(
                                    (item) => {
                                      return (
                                        <tr>
                                          <td
                                            scope="row"
                                            className="table-text text-capitalize align-middle text-center border-1 border-dark p-1"
                                          >
                                            {item.item_name}
                                          </td>
                                          <td
                                            scope="row"
                                            className="table-text text-capitalize align-middle text-center border-1 border-dark p-1"
                                          >
                                            {item.qty}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </>
                              );
                            }
                          )} */}
                          <tr style={{height:"10px"}}></tr>
                          <tr>
                            <th scope="col" colSpan={2} className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              Total Collected
                            </th>
                            <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              {reportData.data.sales_details?.total_collected}
                            </th>
                          </tr>
                          <tr>
                            <th scope="col" colSpan={2} className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              Day End Cash
                            </th>
                            <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              {reportData.data.sales_details?.day_end_cash}
                            </th>
                          </tr>
                          <tr>
                            <th scope="col" colSpan={2} className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              Variance
                            </th>
                            <th className="table-text text-capitalize align-middle text-center border-1 border-dark p-1">
                              {(() => {
                                const diff = Number(changeNumberFormat(reportData.data.sales_details?.total_collected)) -
                                  Number(changeNumberFormat(reportData.data.sales_details?.day_end_cash));

                                return `${diff} ${diff > 0 ? "(excess)" : (diff < 0 ? "(short)" : "")}`;
                              })()}
                            </th>
                          </tr>

                          {reportData?.data && reportData.data?.expenses && 
                            parseInt(getSystemSettings(generalSettings, "view_expense")) === 1 && (
                              <>
                              <tr style={{height:"10px"}}></tr>
                              <tr><th colspan="3" className="text-center">Expense Details</th></tr>
                              <tr>
                                <th scope="col" colSpan={2}>
                                  Type
                                </th>

                                <th>
                                  Amount
                                </th>
                              </tr>
                          
                              {reportData &&
                                reportData.data?.expenses !== null && (
                                reportData.data.expenses && Object.entries(reportData.data.expenses)?.map((food)=>{
                                  totalExp += parseFloat(food[1]);                    
                                  return(
                                    <tr>
                                      <td scope="col" colSpan={2}>{food[0]}</td>                          
                                      <td>{roundOffPrice(food[1])}</td>
                                    </tr>
                                  )
                                })
                                )
                              }
                              <tr>
                                <th scope="col" colSpan={2}>Total</th>                       
                                <th>{roundOffPrice(totalExp)}</th>
                              </tr>                       
                              </>
                            )
                          }

                          {reportData?.data && reportData.data?.cash_purchase_invoices && Object.keys(reportData.data.cash_purchase_invoices).length > 0 && 
                            parseInt(getSystemSettings(generalSettings, "enable_pi_zreport")) === 1 && (
                              <>
                              <tr style={{height:"10px"}}></tr>
                              <tr><th colSpan="3" className="text-center">Purchase Details</th></tr>
                              <tr>
                                <th scope="col" colSpan={2}>
                                  Supplier
                                </th>

                                <th>
                                  Amount
                                </th>
                              </tr>
                          
                              {reportData &&
                                reportData.data?.cash_purchase_invoices !== null && (
                                reportData.data.cash_purchase_invoices && Object.entries(reportData.data.cash_purchase_invoices)?.map((pi)=>{
                                  totalPurchase += parseFloat(pi[1]);                    
                                  return(
                                    <tr>
                                      <td colSpan={2}>{pi[0]}</td>                          
                                      <td>{roundOffPrice(pi[1])}</td>
                                    </tr>
                                  )
                                })
                                )
                              }
                              <tr>
                                <th scope="col" colSpan={2}>Total</th>                       
                                <th>{roundOffPrice(totalPurchase)}</th>
                              </tr>
                              {reportData.data?.sales_details?.total_cash !== undefined && reportData.data?.sales_details?.total_cash !== null && (
                                <tr>
                                  <th scope="col" colSpan={2}>Net Cash After Purchase</th>
                                  <th>{roundOffPrice(Number(reportData.data.sales_details.total_cash) - totalExp - totalPurchase)}</th>
                                </tr>
                              )}
                              </>
                            )
                          }
                          {
                            dayEndCash && reportData.data?.denominator ? (
                              <>
                                <tr style={{height:"10px"}}></tr>
                                <tr>
                                  <th scope="col" className="text-capitalize align-middle text-center border-1 border p-1">Type</th>
                                  <th scope="col" className="text-capitalize align-middle text-center border-1 border p-1" style={{ minWidth: "40px"}}>Total Collected</th>
                                  <th scope="col" className="text-capitalize align-middle text-center border-1 border p-1">Total Payable</th>
                                  <th scope="col" className="text-capitalize align-middle text-center border-1 border p-1">Variance</th>
                                </tr>                                                       
                                <tr>
                                  <td className="text-capitalize align-middle text-center border p-1 font-weight-bold">Cash</td>
                                  <td className="text-capitalize align-middle text-center border p-1" style={{ minWidth: "40px"}}>{reportData.data.denominator?.collected_amount ?? 0}</td>
                                  <td className="text-capitalize align-middle text-center border p-1">{reportData.data.denominator?.total_payable_amount ?? 0}</td>
                                  <td className="text-capitalize align-middle text-center border p-1">{roundOffPrice(reportData.data.denominator?.variance)}</td>
                                </tr>
                                {(reportData.data.denominator?.card_collected_amount !== undefined || reportData.data.denominator?.card_variance !== undefined) && (
                                  <tr>
                                    <td className="text-capitalize align-middle text-center border p-1 font-weight-bold">Card</td>
                                    <td className="text-capitalize align-middle text-center border p-1" style={{ minWidth: "40px"}}>{reportData.data.denominator?.card_collected_amount ?? 0}</td>
                                    <td className="text-capitalize align-middle text-center border p-1">{reportData.data.denominator?.card_total_payable_amount ?? 0}</td>
                                    <td className="text-capitalize align-middle text-center border p-1">{roundOffPrice(reportData.data.denominator?.card_variance)}</td>
                                  </tr>
                                )}
                              </>
                            ) : ""
                          }
                        </tbody>
                      </table> 
                    </div>
                  </div> 
                </div> 
              )
            }
          </div> 
        </div> 
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading <div className={`${dataPaginating && "loading"}`}></div> */}
                    
                    {/* spin loading ends */}
                    <CustomSpinLoader loading={dataPaginating || loading}/>

                    {/* Loading effect */}
                  
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Work Period Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-7 d-flex justify-content-end align-items-center p-0">
                          <div className="d-flex justify-content-end p-0 mr-3">
                            <div className="d-inline mr-3 table-text d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="finish_good"
                                name="finish_good"
                                value="finish_good"
                                onChange={(e) => {
                                  handleReportOption(e);
                                }}
                                checked={
                                  reportOption === "finish_good"
                                }
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="finish_good"
                                style={{fontSize:"16px",borderRadius:"5px"}}
                              >
                                {_t(t("Finish Good"))}
                              </label>
                            </div>

                            <div className="d-inline mr-1 table-text d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="stock"
                                name="stock"
                                value="stock"
                                onChange={(e) => {
                                  handleReportOption(e);
                                }}
                                checked={
                                  reportOption === "stock"
                                }
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="stock"
                                style={{fontSize:"16px",borderRadius:"5px"}}
                              >
                                {_t(t("Stock"))}
                              </label>
                            </div>
                          </div>
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="excel_report"
                              name="excel_report"
                              value="excel"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={
                                option === "excel"
                              }
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="excel_report"
                              style={{fontSize:"16px",borderRadius:"5px"}}
                            >
                              <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Excel"))}
                            </label>
                          </div>

                          <div className="d-inline mr-2 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="print_report"
                              name="print_report"
                              value="print"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={
                                option === "print"
                              }
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="print_report"
                              style={{fontSize:"16px",borderRadius:"5px"}}
                            >
                              <i className="fa fa-print" aria-hidden="true"></i> {_t(t("Print"))}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>
                        <div className="col-2">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>
                        <div className="col-3 t-mb-15 mb-md-0">
                          {authUserInfo.details !== null &&
                            (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager") ? (
                              <Select
                                options={branchForSearch ? branchForSearch : []}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                isClearable
                                styles={customStyle}
                                value={newWorkPeriodReport?.branch || null}
                                classNamePrefix="select"
                                className="sm-text "
                                onChange={handleBranch}
                                maxMenuHeight="200px"
                                placeholder={_t(t("Select a branch")) + ".."}
                              />
                            ) : (
                            <></>
                          )}
                        </div>
                         <div className="col-2 t-mb-15 mb-md-0 text-right">
                          <Select
                            options={[
                              { label: _t(t("Work Period Report")), value: "work_period" },
                              { label: _t(t("POS Session Activity Report")), value: "pos_session" },
                              { label: _t(t("Expense Report")), value: "expense_report" }
                            ]}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            styles={customStyle}
                            value={selectedReportType}
                            classNamePrefix="select"
                            className="sm-text text-left"
                            onChange={(selected) => setSelectedReportType(selected)}
                            maxMenuHeight="200px"
                            isSearchable={false}
                          />
                        </div>
                        <div className="col-3 t-mb-15 mb-md-0 text-right">
                         {/* Action Button */}
                         <button
                            className="btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                            onClick={(e) => getBranchWiseSelected(e)}
                          >
                            {_t(t("Print Selected Report"))}
                          </button>
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-9 t-mb-15"></div>
                        <div className="col-3 t-mb-15 mb-md-0 text-right">
                          {/* Action Button */}
                          <button
                            className="btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                            onClick={(e) => getBranchWiseStock(e)}
                          >
                            Day End Stock Report
                          </button>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default WorkPeriodReport;
